import zeroPad from './zero-pad';

type Options = {
  /**
   * Drop the hours segment until there is an hour to show, for places too
   * tight to hold a full clock.
   */
  compact?: boolean;
};

/**
 * A running duration as HH:MM:SS, for a clock which ticks in front of the user.
 * Hours keep counting past 24 rather than wrapping, so a timer left running
 * overnight still reads as one long stretch.
 */
export default function formatElapsed(
  seconds: number,
  { compact = false }: Options = {}
): string {
  const safe = Math.max(Math.floor(seconds), 0);
  const h = Math.floor(safe / 3600);
  const m = Math.floor((safe % 3600) / 60);
  const s = safe % 60;

  if (compact && h === 0) return `${zeroPad(m)}:${zeroPad(s)}`;
  return `${zeroPad(h)}:${zeroPad(m)}:${zeroPad(s)}`;
}
